<template>
  <v-container class="mt-10" style="max-width: 500px">
    <v-card>
      <v-card-title class="headline">Trocar Senha</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="currentPassword"
            :rules="[v => !!v || 'Senha atual é obrigatória']"
            label="Senha Atual"
            type="password"
            required
          ></v-text-field>

          <v-text-field
            v-model="newPassword"
            :rules="[v => !!v || 'Nova senha é obrigatória']"
            label="Nova Senha"
            type="password"
            required
          ></v-text-field>

          <v-text-field
            v-model="confirmPassword"
            :rules="[
              v => !!v || 'Confirmação obrigatória',
              v => v === newPassword || 'As senhas não coincidem',
            ]"
            label="Confirmar Nova Senha"
            type="password"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="trocarSenha">Trocar Senha</v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import _usuario from '../../services/usuario/usuario-servico.js';
export default {
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      valid: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
    };
  },
  mounted() {
    if (this.$route.params.id != null) {
      this.usuarioId = this.$route.params.id;
    }
  },
  methods: {
    async trocarSenha() {
      if (this.$refs.form.validate()) {
        try {
          const result = await _usuario.trocarSenha(
            this.usuarioId,
            this.currentPassword,
            this.newPassword
          );

          if (result) {
            this.snackbarText = 'Senha trocada com sucesso!';
            this.snackbarColor = 'success';
            this.snackbar = true;
          } else {
            this.currentPassword = '';
            this.snackbarText = 'Senha atual não confere.';
            this.snackbarColor = 'error';
            this.snackbar = true;
          }

          // Limpa os campos
        } catch (error) {
          let mensagem = 'Erro ao trocar senha.';

          if (error.response && error.response.data && error.response.data.detail) {
            mensagem = error.response.data.detail;
          }

          this.snackbarText = mensagem;
          this.snackbarColor = 'error';
          this.snackbar = true;
        }
      } else {
        this.newPassword = '';
        this.confirmPassword = '';
        this.snackbarText = 'Preencha os campos corretamente!';
        this.snackbarColor = 'error';
        this.snackbar = true;
      }
    },
  },
};
</script>
